let token = false;
const TOKEN_KEY_STORAGE = 'token-esm';
const Constantes = {
	isDev: () => {
		return document.location.href.indexOf(':3000') !== -1 || document.location.href.indexOf(':8000') !== -1;
	},
	setToken: (t) => {
		token = t
		localStorage.setItem(TOKEN_KEY_STORAGE, token);
	},
	getToken: function () {
		if (this.isDev() && document.location.href.indexOf(':8000') === -1) {
			return localStorage.getItem(TOKEN_KEY_STORAGE);
		}
		return window.TOKEN;
	}
};
export default Constantes;
